import React from 'react';

export default function ListarConcedentes(props) {
	const { listaDeCampos, onSelect } = props;

	return (
		<div>
			<h5>Selecione o Campo de Estágio que deseja cadastrar o ateste</h5>
			<table className="table table-striped table-hover">
				<thead>
					<tr>
						<th>Concedente</th>
						<th>Nome</th>
						<th>Telefone</th>
						<th>Email</th>
						<th>Município</th>
					</tr>
				</thead>
				<tbody>
					{
						listaDeCampos.map(campo => {
							const { concedente } = campo;

							return (
								<tr key={campo.id} onClick={() => onSelect(campo)}>
									<td>{concedente !== null ? concedente.nome : ''}</td>
									<td>{campo.nome}</td>
									<td>{campo.telefone}</td>
									<td>{campo.email}</td>
									<td>{campo.endereco.cidade}</td>
								</tr>
							);
						})
					}
				</tbody>
			</table>
		</div>
	);
}
